import { type CalendarItem } from '../types'

/**
 * What a crowded day left out, counted by kind.
 *
 * The names said very little: a day that hides twenty things hides more names
 * than anyone reads off a tooltip, and the day panel behind "+N more" gives
 * the full list anyway. The counts answer the question the button raises —
 * how much of what kind of work is under there.
 *
 * Anything that is not a moment is counted as content. Stories and blocks are
 * part of the item type but the month does not draw them yet; when it does,
 * they earn a count of their own.
 */
export const notShownSummary = (items: readonly CalendarItem[]): string => {
  const moments = items.filter((item) => item.kind === 'moment').length
  const content = items.length - moments

  return [
    moments === 0 ? '' : `${moments} more moment${moments === 1 ? '' : 's'}`,
    content === 0
      ? ''
      : `${content} more piece${content === 1 ? '' : 's'} of content`,
  ]
    .filter((part) => part !== '')
    .join(' · ')
}
